import { ALLOWED_DOC_TYPES, MIME_TYPE_DOC_TYPE_MAP } from './constants';
import MS_DOC_ICON from '../../assets/msword-icon.png';
import PDF_ICON from '../../assets/pdf-icon.png';
import FILE_ICON from '../../assets/file-icon.jpg';

export const getImageURLBasedOnMimeType = (mimeType, previewURL) => {
  const doctype = MIME_TYPE_DOC_TYPE_MAP[mimeType];
  switch (doctype) {
    case ALLOWED_DOC_TYPES.IMAGE:
      return previewURL;
    case ALLOWED_DOC_TYPES.DOC:
      return MS_DOC_ICON;
    case ALLOWED_DOC_TYPES.PDF:
      return PDF_ICON;
    default:
      return FILE_ICON;
  }
};
